<template>
    <div id="userList">
        <div class="search" id="search">
            <div class="p_select">
                <div class="search_label">SA</div>
                <el-select clearable v-model="saIdCarModel" :disabled="disableCheckSAT" filterable placeholder="请选择SA" @change="changeSAcarModel">
                    <el-option
                            v-for="item in orginUserArr"
                            :key="item.saId"
                            :label="item.saName"
                            :value="item.saId"
                    ></el-option>
                </el-select>
            </div>
            <div class="p_select">
                <el-select v-model="positionIdCarModel" :disabled="disableCheckPositionT" clearable filterable placeholder="请选择部位" @change="changeSAcarModel">
                    <el-option
                            v-for="item in positionList"
                            :key="item.positionId"
                            :label="item.positionName"
                            :value="item.positionId"
                    ></el-option>
                </el-select>
            </div>
            <div class="p_select search_day_list" >
                <div @mouseover="onMouseOver('start')" @mouseleave="onMouseleave('start')">
                    <el-date-picker
                            v-model="startTimeCarModel"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerDayOptions"
                            prefix-icon="''"
                            class="datepicker"
                            placeholder="选择开始日期"> </el-date-picker>
                    <i class="el-icon-date" ref="iconDateStart"></i>
                </div>
            </div>
            <div class="p_select search_day_list" >
                <div @mouseover="onMouseOver('end')" @mouseleave="onMouseleave('end')">
                    <el-date-picker
                            v-model="endTimeCarModel"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerDayOptions"
                            prefix-icon="''"
                            class="datepicker"
                            placeholder="选择结束日期"> </el-date-picker>
                    <i class="el-icon-date" ref="iconDateEnd"></i>
                </div>
            </div>
            <div class="p_select">
                <el-input placeholder="请输入分割里程" v-model="mile" type="number">
                    <template slot="append">万km</template>
                </el-input>
            </div>
            <div class="p_select">
                <el-button class="search_btn" @click="getCarModelAndItem">查询</el-button>
                <el-button class="add_btn" @click="exportTable('#carModelAndItem')"  >导出</el-button>
            </div>
        </div>
        <div class="table">
            <el-table id="carModelAndItem" :data="carModelAndItemData" border style="width: 100%;" ref="table_5" :height=winHeight show-summary :header-cell-style="tableHeaderColor" :span-method="objectSpanMethod">
                <el-table-column prop="saName" label="SA" v-if="showSA"> </el-table-column>
                <el-table-column prop="positionName" label="部位" v-if="!showSA" > </el-table-column>
                <el-table-column prop="seriesName" label="车型" > </el-table-column>
                <el-table-column  :label="`${mile }万公里以下检测数量`">
                    <el-table-column prop="testNum0" :label="`检测${tag}数`" sortable> </el-table-column>
                    <el-table-column prop="faultNum0" :label="`检出${tag}数`" sortable> </el-table-column>
                    <el-table-column prop="dealNum0" :label="`成交${tag}数`" sortable> </el-table-column>
                </el-table-column>
                <el-table-column :label="`${mile }万公里以上检测数量`" >
                    <el-table-column prop="testNum1" :label="`检测${tag}数`" sortable> </el-table-column>
                    <el-table-column prop="faultNum1" :label="`检出${tag}数`" sortable> </el-table-column>
                    <el-table-column prop="dealNum1" :label="`成交${tag}数`" sortable > </el-table-column>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
  import net from "../../assets/js/public";
  import XLSX from "xlsx";
  import FileSaver from "file-saver";
  export default {
    name: "detectionSummary",
    data(){
      return {
        carModelAndItemData: [], // 车型+项目维度
        positionIdCarModel:'', // 部位
        saIdCarModel:'', // SA
        startTimeCarModel:'', //开始时间
        endTimeCarModel:'',
        mile:'',
        showSA:false,
        showPosition:false,
        tag:'',

        disableCheckSAT: false,
        disableCheckPositionT: false,

        orginUserArr:[],
        positionList:[],

        winHeight:'200',



        pickerDayOptions: { // 按天 当天、当月可选
          disabledDate(time) {
            return time.getTime() > Date.now() + 1 * 24 * 60 * 60 * 1000;
          }
        },
      }
    },
    created() {

      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      if(signInfo.orgId > 0){
        this.orgId = signInfo.orgId
      }
      let obj = new Date();
      let month = obj.getMonth() + 1;
      if (month < 10) month = "0" + month;
      let day = obj.getDate();
      if (day < 10) day = "0" + day;
      // 明天
      let after = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)//后一天
      let afterMonth = after.getMonth() + 1;
      if (afterMonth < 10) afterMonth = "0" + afterMonth;
      let afterDay = after.getDate()
      if (afterDay < 10) afterDay = "0" + afterDay;

      let monthFirstDay = obj.getFullYear() + "-" + month + "-01"; //本月第一天
      let monthAfterDay = after.getFullYear() + "-" + afterMonth + "-" + afterDay; //明天


      this.startTimeCarModel = monthFirstDay
      this.endTimeCarModel = monthAfterDay

      if(this.orgId){
        this.orgChange(this.orgId)
      }
      this.getPositionList()


    },
    methods:{
      onMouseOver(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'none';
        }else {
          this.$refs.iconDateEnd.style.display = 'none';
        }
      },
      onMouseleave(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'block';
        }else {
          this.$refs.iconDateEnd.style.display = 'block';
        }
      },
      // SA 维度数据 合计
      getSummariesSATestAndDealData(param){
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if(index === 9){
            sums[index] = this.itemFaultNumRateAll+'%'
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            // sums[index] += ' 元';
          } else {
            sums[index] = '-';
          }
        });

        return sums;
      },
      // 表头样式
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return "background-color:#F3F7FB; color: #364556; text-align: left;font-size: 14px;height: 48px;font-weight: 500;font-family: 'PingFang SC';";
      },
      cellStyle({ row, column, rowIndex, columnIndex }) {
        if(row.columnIndex == 0){
          return 'color: #0D0E12;font-weight: 500;font-size: 14px;'
        }else{
          return 'color: #0D0E12;font-weight: 400;'
        }
      },
      // 合并列
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0 ) {
          if (rowIndex  === 0) {
            this.$nextTick(() => {
              this.$refs['table_5'].doLayout();
            })
            return {
              rowspan: this.carModelAndItemData.length,
              colspan: 1
            };
          }else {
            return [0, 0]
          }
        }
      },

      // 获取所有部位
      getPositionList(){
        net.request("admin/manage/parts/getPositionList","post").then(res => {
          if (res.code === 0) {
            this.positionList = res.data
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        })
      },
      // 选择站点  获取SA
      orgChange(orgId){
        const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
        net.request("admin/manage/report/getSAByOrg", "post", { orgId: orgId }).then(res => {
          if (res.code === 0) {
            this.orginUserArr = res.data;
          } else {
            this.$message({
              message: res.msg,
              type: 'warning',
              duration:2000,
              offset:windiwHight/2
            });
          }
        });
      },

      changeSAcarModel(){
        if((this.saIdCarModel==null || this.saIdCarModel==='') && (this.positionIdCarModel==null || this.positionIdCarModel==='')){
          this.disableCheckSAT = false
          this.disableCheckPositionT = false
        }else if(this.saIdCarModel==null || this.saIdCarModel===''){
          this.tag = '项目'
          this.disableCheckSAT = true
          this.disableCheckPositionT = false
        }else{
          this.tag = '台'
          this.disableCheckSAT = false
          this.disableCheckPositionT = true
        }
      },
      // 车型+项目维度
      getCarModelAndItem(){
        const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
        /*if ( (this.saIdCarModel === "" || this.saIdCarModel === null)&& (this.positionIdCarModel === "" || this.positionIdCarModel === null)) {
          this.$message({
            message: "请选择SA或者部位",
            type: 'warning',
            duration:2000,
            offset:windiwHight/2
          });
          return;
        }*/
        if ( this.mile === "" || this.mile === null) {
          this.$message({
            message: "请输入分割里程",
            type: 'warning',
            duration:2000,
            offset:windiwHight/2
          });
          return;
        }
        if(this.startTimeCarModel *1 !== 0 && this.endTimeCarModel *1 !== 0 ){
          if (this.startTimeCarModel >= this.endTimeCarModel ) {
            this.$message({
              message: "结束日期不得小于或等于开始日期",
              type: 'warning',
              duration:2000,
              offset:windiwHight/2
            });
            // net.message(this, "结束日期不得小于或等于开始日期", "warning");
            return;
          }
        }

        const body = {
          beginDate: this.startTimeCarModel || null,
          endDate: this.endTimeCarModel || null,
          positionId: this.positionIdCarModel,
          saId: this.saIdCarModel,
          mile: this.mile * 10000
        }

        let saItem = ''
        let positionItem = ''

        if(this.saIdCarModel){
          saItem = this.orginUserArr.find((item)=>{
            return item.saId === this.saIdCarModel;
          })
          this.showSA = true
        }
        if(this.positionIdCarModel){
          positionItem = this.positionList.find((item)=>{
            return item.positionId === this.positionIdCarModel;
          })
          this.showSA = false
        }



        // if(this.saIdCarModel){
        //   saItem = this.orginUserArr.find((item)=>{
        //     return item.saId === this.saIdCarModel;
        //   })
        //   this.showSA = true
        // }else {
        //   positionItem = this.positionList.find((item)=>{
        //     return item.positionId === this.positionIdCarModel;
        //   })
        //   this.showSA = false
        // }

        net.request("admin/manage/report/getCarModelAndItem", "post", null, body).then(res => {
          if (res.code == 0) {
            this.$message({
              message: '查询成功',
              type: 'success',
              duration:2000,
              offset:windiwHight/2
            });
            this.$nextTick(() => {
              this.$refs['table_5'].doLayout();
            })
            let data = res.data
            data.forEach(item => {
              item.saName = saItem.saName || ''
              item.positionName = positionItem.positionName || ''
            })
            this.carModelAndItemData = data
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度
            const searchHeight = document.getElementById("search").offsetHeight; // 头部查询部分的高度
            this.winHeight = windiwHight - searchHeight - 120;
          } else {
            this.$message({
              message: res.msg,
              type: 'warning',
              duration:2000,
              offset:windiwHight/2
            });
          }
        })
      },
      // 导出数据
      exportTable(elTableId) {
        var wb = XLSX.utils.table_to_book(document.querySelector(elTableId));
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            "检车车型成交合计.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
      },

      // 设置滚动高度
      setWindowHeight() {
        const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度
        // const searchHeight = document.getElementById("search").offsetHeight; // 头部查询部分的高度
        this.winHeight = windiwHight  - 186;
      },
      //监听键盘Esc按键事件
      handleKeyup(event){
        let self = this;
        const e = event || window.event || arguments.callee.caller.arguments[0]
        if(!e) return
        if (e.keyCode == 27) {
          let routeNmae = self.$route.name
          if(routeNmae != 'OperationDataStatistics'){
            e.stopImmediatePropagation();
            self.$router.replace({ name: 'OperationDataStatistics' })
          }
        }
      },

    },
    mounted() {
      window.addEventListener('keyup',this.handleKeyup)
    },
    beforeDestroy() {
      window.removeEventListener('keyup',this.handleKeyup)
    }
  };
</script>

<style lang="less" scoped>
    #userList {
        display: flex;
        flex-direction: column;
        margin: 24px 0 0 24px;
        background: #fff;
        padding-left: 24px;
        .search {
            background: #fff;
            padding-top: 24px;
            margin-bottom: 24px;
            .p_select {
                display: flex;
                margin-right: 24px;
                font-size: 12px;
                float: left;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }
            .search_btn {
                /*width: 76px;*/
                /*height: 36px;*/
                background: #2B54FC;
                box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 14px;
            }
            .add_btn {
                /*width: 76px;*/
                height: 36px;
                background: rgba(148, 170, 204, 0.08);
                border: 1px solid #2B54FC;
                border-radius: 4px;
                font-size: 14px;
                color: #2B54FC;
            }
        }

        .pagination {
            position: relative;
            margin-top: 20px;

            .el-pagination {
                position: absolute;
                left: 0px;
            }

            .number .active {
                background: #009688 !important;
            }
        }
    }
</style>
<style lang="less">
    .el-table .cell {

        white-space: pre-line;
    }
</style>